// Import React and ReactDOM

// Register AppView platform FIRST - before any other imports that might use it
import { App } from "@/setup/app"

import { registerAppViewPlatform } from "@be-miniapp/platform"

import "@be-miniapp/ui/import-style"
import "@be-miniapp/i18n/init"

import { APP_VERSION } from "@be-miniapp/app-configs"
import { bootstrap } from "@be-miniapp/core"
import { captureException, createMonitorConfig } from "@be-miniapp/logging"

registerAppViewPlatform()

function renderBootstrapError(error: unknown) {
  captureException(error, { tags: { feature: "bootstrap" } })

  const message = error instanceof Error ? error.message : String(error)
  console.error("[app] Failed to bootstrap", error)

  const root = document.getElementById("app")
  if (!root) return

  root.innerHTML = `
    <div style="padding:24px;font-family:system-ui,sans-serif">
      <p style="font-weight:600;margin:0 0 8px">Không thể khởi động ứng dụng</p>
      <p style="margin:0;color:#666;font-size:14px">${message}</p>
    </div>
  `
}

async function initApplication() {
  await bootstrap({
    monitor: createMonitorConfig(APP_VERSION, "appview"),
    renderApp: () => <App />,
  })
}

initApplication().catch(renderBootstrapError)
